import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './template.vue';

@Component({
    mixins: [template],
    components: {},
})
export default class Pagination extends Vue {
    @Prop()
    currentPageIndex: number;
    @Prop()
    rowsPerPage: number;
    @Prop()
    allRowsCount: number;

    get start() {
        return this.rowsPerPage * this.currentPageIndex + 1;
    }
    get end() {
        if (this.currentPageIndex === this.totalPages) {
            return this.allRowsCount;
        }
        return this.rowsPerPage * (this.currentPageIndex + 1);
    }
    get totalPages() {
        return Math.floor(this.allRowsCount / this.rowsPerPage);
    }

    created() {
        console.log('created', this.allRowsCount, this.rowsPerPage, this.totalPages);
    }

    prev() {
        if (this.currentPageIndex > 0) {
            this.$emit('updateCurrentPageIndex', this.currentPageIndex - 1);
        }
    }

    next() {
        if (this.currentPageIndex < this.totalPages) {
            this.$emit('updateCurrentPageIndex', this.currentPageIndex + 1);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/shipments-4-shippers/components/shipments/components/pagination/index.ts